import React, {useEffect, useState} from 'react'
import { MainWrapper } from '../component/MainWrapper'
import { InputSearch } from 'sr/helpers/InputSearch'
import DropDown from 'sr/helpers/ui-components/DropDown.tsx'
import { JobsListingCard } from './component/JobsListingCard'
import { TopBar } from '../component/TopBar'
import { FormattedMessage, useIntl } from 'react-intl'
import { getUserDetails } from 'sr/helpers/functions/getUserDetails'
import { getJobs } from 'sr/utils/api/cleaner/jobs/getJobs'
import { Empty } from '../candidates/component/Empty'
import ContentWithLoader from 'sr/layout/common/ContentLoader'
import { JobsLoadingCard } from './JobsLoadingCard'
import Job from 'app/pages/component/types/Job'
import { Pagination } from 'app/pages/component/Pagination'
import { TermsAgreePopup } from 'app/pages/module/auth/TermsAgreePopup'
export const JobsListing = () => {
  const intl = useIntl()
    const [jobs, setJobs] = useState<Job[]>([]);
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [id, setId] = useState(null)
    const [loader, setLoader] = useState(false)
    const [totalPage, settotalPage] = useState<number>(1);
    const [totalJobs, setTotalJobs] = useState(0)
    const [filterjobs, setFilterJobs] = useState<Job[]>([]);
    const [openPauseCount, setOpenPauseCount] = useState(0)
    const [closeCount, setCloseCount] = useState(0)
    const [tab, setTab] = useState('Open and Pause')
    const [search, setSearch] = useState<string>()
    const [searchLocation, setSearhLocation] = useState<string>()
    const [sortBy, setSortBy] = useState('')

    useEffect(()=> {
      const getdetails = getUserDetails()
      setId(getdetails.user_id)
    },[id])

    const fetchJobCounts = async () => {
      const queryParams = new URLSearchParams()
      if (id) queryParams.append('company_id', id.toString())
      queryParams.append('page', '1')
      queryParams.append('limit', '1')
      queryParams.append('filter', JSON.stringify({ status: { $in: ['open', 'pause', 'closed'] } }))
      if (search) queryParams.append('job_title', `/.*${search}./i`)
      if (searchLocation) queryParams.append('address', searchLocation)
      const result = await getJobs(queryParams)
      if (result?.success === true) {
        const obj = result?.pagination?.statusCounts || {}
        setOpenPauseCount((obj['open'] || 0) + (obj['pause'] || 0))
        setCloseCount(obj['closed'] || 0)
      }
    }
    const fetchJobs = async ()=> {
      setLoader(true)
      const queryParams = new URLSearchParams();  
      if (id) queryParams.append('company_id', id.toString());
      if (page) queryParams.append('page', page.toString());
      if (limit) queryParams.append('limit', limit.toString())
      if (sortBy) queryParams.append('sort', sortBy)
      if (tab==='Open and Pause')  {
        queryParams.append('filter', JSON.stringify({"status":{"$in":["open","pause"]}}))
      }
      else {
        queryParams.append('filter', JSON.stringify({"status":{"$in":["closed"]}}))
      }
      if (search) queryParams.append('job_title', `/.*${search}./i`)
      if (searchLocation) queryParams.append('address', searchLocation)  
      const result = await getJobs(queryParams)
      if(result?.success===true) {
      setJobs(result?.data)
      setFilterJobs(result?.data)
      setTotalJobs(result?.pagination.page * result?.pagination.total)
      settotalPage(Math.ceil(result?.pagination.total/limit))
      setLoader(false)
      }
    }
    useEffect(()=> {
      
      if(id) {
      fetchJobs()
      }
    },[id, page, limit, sortBy, tab, search, searchLocation])

    useEffect(() => {
      if (id) {
        fetchJobCounts()
      }
    }, [id, search, searchLocation])

    const refreshJobsAndCounts = async () => {
      await fetchJobs()
      await fetchJobCounts()
    }
  return (
    <MainWrapper>
        <div className='py-3'>
 <TopBar title = {<FormattedMessage id="RECRUITER.POSTED.JOB.JOB.TITLE" defaultMessage="Jobs" /> } />
    <div className='flex items-center mb-5'>
<div onClick={()=> setTab('Open and Pause')} className={`rounded-l-lg  px-5 py-2.5  cursor-pointer border border-neutral-200 ${tab === 'Open and Pause' ? 'bg-[#ff39b3]  text-white font-bold' :'bg-white text-[#0078ae] font-bold' }`}>
<FormattedMessage id="RECRUITER.POSTED.JOB.STATUS" defaultMessage="Open and Paused {number}" values={{number:openPauseCount}}/>  
</div>
<div onClick={()=> setTab('Closed')} className={`rounded-r-lg  px-5 py-2.5  cursor-pointer border border-neutral-200 ${tab === 'Closed' ? 'bg-[#ff39b3] font-bold  text-white' :'bg-white text-[#0078ae] font-bold' }`}>
<FormattedMessage id="RECRUITER.POSTED.JOB.CLOSED" defaultMessage="Closed {number}" values={{number:closeCount}}/>  
</div>
    </div>
    <div className='flex items-center justify-between'>
      <div className='flex justify-start items-center space-x-4'>
        <div>
      <p className='text-base '> <FormattedMessage id="RECRUITER.POSTED.JOB.TITLES" defaultMessage="Search Job Titles" />  </p>

<InputSearch onChange={(e)=> setSearch(e.target.value)}  value={search} noicon = {true} className="border border-black rounded-lg my-0" 
placeholder={intl.formatMessage({
    id: 'INPUT.SEARCH.JOB.TITLES.PLACEHOLDER',
    defaultMessage: 'Search Candidates',
  })}
 height = 'h-8' borderColor='border-[#275df5]' inputdiv="rounded-lg w-60">
                                      </InputSearch>
                                    
</div>

<div>
      <p className='text-base '> <FormattedMessage id="INPUT.SEARCH.LOCATION.TITLE" defaultMessage="Search Location" />  </p>
      <InputSearch onChange={(e:any)=> setSearhLocation(e.target.value)} noicon = {true} inputdiv="rounded-lg w-60" className="border border-black rounded-lg my-0" placeholder={intl.formatMessage({ id:"INPUT.SEARCH.LOCATION.PLACEHOLDER", defaultMessage:"Search Location" })} height = 'h-8' borderColor='border-[#275df5]'>
                                      </InputSearch>
    </div>
    
    </div>
    <div className='flex justify-start items-center space-x-4 my-4'>
      <DropDown value={sortBy} onChange={(e)=> setSortBy(e.target.value)} dropdowndiv="mt-0" label={intl.formatMessage({
    id: 'RECRUITER.POSTED.JOB.FILTER.SORTBY.TITLE',
    defaultMessage: 'Sort By:',
  })} className="rounded-lg" labelMargin="pb-0.5">
        <option> <FormattedMessage id="RECRUITER.POSTED.JOB.FILTER.SORTBY.TYPE" defaultMessage="Job Title" />  </option>
        <option value={'job_title'}> A - Z </option>
        <option value={'-job_title'}> Z - A </option>
      </DropDown>
  
    </div>
    </div>
    <ContentWithLoader loading={loader} content={<JobsLoadingCard></JobsLoadingCard>}>
    {filterjobs?.length > 0 ? (

    filterjobs?.map((data)=> (<>
   <JobsListingCard jobs={data} fetchJobF={refreshJobsAndCounts}/>
   </>
   
   ))):
   tab==='Open and Pause' ?
     (<Empty text = {`No jobs have been added yet`}></Empty>)
     :
     (<Empty text = {`You do not have any job ${tab}`}></Empty>)
   }
  { filterjobs?.length >0 &&
  <Pagination page={page} totalPage={totalPage} setPage={setPage} />
}
   </ContentWithLoader>
   <TermsAgreePopup></TermsAgreePopup>
    </div>

    </MainWrapper>
  )
}
